import { inject, Injectable, Type } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MpSelfEnrolmentFlowStepEnum } from './mp-self-enrolment-flow-step.enum';
import { MpSelfEnrolmentPersonalInformationComponent } from './mp-self-enrolment-personal-information/mp-self-enrolment-personal-information.component';
import { MpSelfEnrolmentContactInformationComponent } from './mp-self-enrolment-contact-information/mp-self-enrolment-contact-information.component';
import { MpSelfEnrolmentLoginDetailsComponent } from './mp-self-enrolment-login-details/mp-self-enrolment-login-details.component';
import { Router } from '@angular/router';
import { Routes } from '../../../../../routes/routes';

@Injectable()
export class MpSelfEnrolmentNavService {
  private router = inject(Router);

  public canDeactivate = false;

  private StepComponents: Record<MpSelfEnrolmentFlowStepEnum, Type<any>> = {
    [MpSelfEnrolmentFlowStepEnum.PersonalInformation]: MpSelfEnrolmentPersonalInformationComponent,
    [MpSelfEnrolmentFlowStepEnum.ContactInformation]: MpSelfEnrolmentContactInformationComponent,
    [MpSelfEnrolmentFlowStepEnum.LoginDetails]: MpSelfEnrolmentLoginDetailsComponent
  };

  private _currentStep = new BehaviorSubject<MpSelfEnrolmentFlowStepEnum>(
    MpSelfEnrolmentFlowStepEnum.PersonalInformation
  );
  public currentStep$ = this._currentStep as Observable<MpSelfEnrolmentFlowStepEnum>;

  public currentStepComponent$ = this.currentStep$.pipe(map(currentStep => this.StepComponents[currentStep]));

  public goForward(): void {
    this.currentStep$.pipe(take(1)).subscribe(step => this._currentStep.next(step + 1));
  }

  public goBack(): void {
    this.currentStep$.pipe(take(1)).subscribe(step => this._currentStep.next(step - 1));
  }

  public goToLogin(): void {
    this.canDeactivate = true;
    this.router.navigate([Routes.signIn()]).then();
  }

  public goToEmailVerification(email: string): void {
    this.canDeactivate = true;
    this.router.navigate([Routes.mpEnterEmailVerification()], { queryParams: { email } }).then();
  }
}
